import React from "react";
import { bool, func, string } from "prop-types";
import { Button, BUTTON_TYPES, BUTTON_VARIANT } from "#library/components/Button";
import styles from "./CellApply.module.css";
export var CellApply = function CellApply(props) {
  var clearLabel = props.clearLabel,
    onClear = props.onClear,
    applyLabel = props.applyLabel,
    onApply = props.onApply,
    _props$disabled = props.disabled,
    disabled = _props$disabled === void 0 ? false : _props$disabled;

  /* we use onClick and onTouchStart to allow click to work on touch event (like on mobile) cf. https://github.com/JedWatson/react-select/issues/3076 */
  return /*#__PURE__*/React.createElement("div", {
    className: styles["jds-CellApply"]
  }, /*#__PURE__*/React.createElement(Button, {
    type: BUTTON_TYPES.BUTTON,
    variant: BUTTON_VARIANT.NAKED,
    minor: true,
    onClick: onClear,
    onTouchStart: onClear,
    disabled: disabled
  }, clearLabel), /*#__PURE__*/React.createElement(Button, {
    minor: true,
    onClick: onApply,
    onTouchStart: onApply
  }, applyLabel));
};
CellApply.propTypes = {
  clearLabel: string.isRequired,
  onClear: func.isRequired,
  applyLabel: string.isRequired,
  onApply: func.isRequired,
  disabled: bool
};